import {Component, OnInit} from '@angular/core';
import {environment} from '../../../environments/environment';
import {AppMemoryService} from '../../core/app-memory.service';

@Component({
    selector: 'app-auth-footer',
    templateUrl: './auth-footer.component.html',
    styleUrls: ['./auth-footer.component.less']
})
export class AuthFooterComponent implements OnInit {

    public availableCountries = [];

    constructor(public appMemory: AppMemoryService) {
    }

    ngOnInit() {
        Object.keys(environment.availableCountries).forEach(country => {
            if(country !== environment.country) {
                this.availableCountries.push({
                    country: country,
                    url: environment.availableCountries[country]
                })
            }
        });
    }

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/app/auth/auth-footer/auth-footer.component.ts